module.exports = __webpack_public_path__ + "img/acypi-02.b7e266a6.jpg";